var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ staticClass: "thumbnail-options" }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _vm.label
        ? _c("div", { staticClass: "label" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.thumbnailChoices, function(thumbnail, index) {
        return _c(
          "div",
          {
            key: thumbnail,
            class:
              "thumbnail-option thumbnail-" +
              index +
              " " +
              (thumbnail === _vm.selectedValue ? "selected" : ""),
            on: {
              click: function($event) {
                return _vm.handleClick(thumbnail)
              }
            }
          },
          [
            _c("img", { attrs: { src: thumbnail, alt: "Thumbnail option" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "selected-overlay" },
              [
                _c("div", { staticClass: "background" }),
                _vm._v(" "),
                _c("icon", { attrs: { icon: "check_circle" } })
              ],
              1
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm.helper
        ? _c("div", { staticClass: "helper" }, [
            _vm._v("\n    " + _vm._s(_vm.helper) + "\n  ")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }